import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import {
  Button,
  ButtonGroup,
  ListItemIcon,
  MenuItem,
  MenuList,
  Popover,
} from '@mui/material';
import { ReactElement, ReactEventHandler, useRef, useState } from 'react';

interface MenuOption {
  name: string;
  icon?: ReactElement;
  onClick: ReactEventHandler;

  disabled?: boolean;
}

const SplitButton = ({
  disabled = false,
  endIcon,
  name,
  onClick,
  options,
}: {
  disabled?: boolean;
  endIcon: ReactElement;
  name: string;
  onClick: ReactEventHandler;
  options: MenuOption[];
}) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef<HTMLDivElement>(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpen(false);
  };

  return (
    <>
      <ButtonGroup
        color="secondary"
        disabled={disabled}
        disableElevation={disabled}
        ref={anchorRef}
        variant="contained"
        size="small"
      >
        <Button endIcon={endIcon} onClick={onClick}>
          {name}
        </Button>
        <Button
          aria-controls={open ? 'split-button-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-label="options"
          aria-haspopup="menu"
          onClick={handleToggle}
        >
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>
      <Popover
        anchorEl={() => anchorRef.current}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={open}
        onClose={handleClose}
        sx={{ marginTop: 1 }}
        elevation={1}
      >
        <MenuList autoFocusItem>
          {options.map(({ name, onClick, icon, disabled }) => (
            <MenuItem
              key={name}
              onClick={(data) => {
                onClick(data);
                setOpen(false);
              }}
              disabled={disabled}
            >
              <ListItemIcon>{icon}</ListItemIcon>
              {name}
            </MenuItem>
          ))}
        </MenuList>
      </Popover>
    </>
  );
};

export default SplitButton;
